var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ua-checkbox', { 'is-checked': _vm.value }, { 'is-disabled': _vm.disabled }],on:{"click":_vm.onClick}},[_c('span',{staticClass:"ua-checkbox__icon iconfont icon-a-16-1px-SUCEESS"})])}
var staticRenderFns = []

export { render, staticRenderFns }